// Version 3 är standard från 14 okt (Fahd 11 okt): den rena adressen ger v3, och ?ui=v1 ger v1 första veckan.
// ?ui=v2 från förr ger också version 3, och boot.jsx byter adressen till v3 (v3Sok). Länkar som v1 äger
// (säljarlänken ?k=, ?plats=, ?utfall=, mejlens ?vy=motesbokning&panel=..., ?onboarding=, ?anslut=, ?bokare=, avtalets ?signera=) öppnar
// fortfarande v1, annars går de sönder. HashRouter byter bara det som står efter #, så ?ui står kvar.
const V1_LANKAR = ['k', 'plats', 'utfall', 'vy', 'panel', 'flik', 'kund', 'onboarding', 'anslut', 'bokare', 'signera'];
export function wantsV2(location) {
  try {
    const q = new URLSearchParams(location.search);
    const ui = q.get('ui');
    if (ui === 'v3' || ui === 'v2') return true;
    if (ui) return false;
    return !V1_LANKAR.some((p) => q.has(p));
  } catch { return false; }
}
/** Sökdelen med ?ui=v2 bytt mot ?ui=v3, eller null när inget ska bytas. */
export function v3Sok(search) {
  const q = new URLSearchParams(search);
  if (q.get('ui') !== 'v2') return null;
  q.set('ui', 'v3');
  return `?${q}`;
}
